export enum EnterpriseAuthResult {
	Permitted = "permitted",
	Forbidden = "forbidden",
	Error = "error",
}
